module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/folder-add.40835246.svg";